import { useLocation } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { LegacyLogin } from '../containers/Login/LegacyLogin';
import styled from 'styled-components';

const SLayout = styled(Layout)`
  min-height: 100vh;
  height: 100%;
`;

export const LegacyLoginPage = () => {
  const location = useLocation();

  const backTo = location.pathname.includes('region')
    ? location.pathname.substring(0, location.pathname.indexOf('/region'))
    : 'login';

  return (
    <SLayout backBtn to={backTo} showLanguageSelector={false} isAuthLayout={false}>
      <LegacyLogin mode={location.pathname.includes('sso') ? 'sso' : undefined} />
    </SLayout>
  );
};
